import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	GetMyChallengesAPIResponse,
	GetPrepPlanByIdAPIResponse,
	GetPrepPlanPracticeSessionAPIResponse,
	StartChallengeAPIResponse,
} from 'types';

const baseUrl = `${API_ENDPOINT}/prep-plan`;

export const getPracticeSessionQuestionById = async (
	assessQuestionId: string,
	questionId: string,
): Promise<GetPrepPlanPracticeSessionAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/get-prep-plan-practice-session`, {
		assessQuestionId,
		questionId,
	});
	return response.data;
};

export const getPrepePlanById = async (id?: string): Promise<GetPrepPlanByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-details`, { params: { id } });
	return response.data;
};

export const getMyChallenges = async (): Promise<GetMyChallengesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/my-challenges`);
	return response.data;
};

export const startMyChallenge = async (templateId: string): Promise<StartChallengeAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/start-challenge`, { templateId });
	return response.data;
};
